import { Share } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useEffect, useState } from 'react';

const AppShareButton = ({ title, text, url }) => {
  const [canShare, setCanShare] = useState(false);

  useEffect(() => {
    if (navigator.share) {
      setCanShare(true);
    }
  }, []);

  const handleShare = async () => {
    try {
      await navigator.share({
        title,
        text,
        url,
      });
    } catch (err) {
      console.error('Error sharing:', err);
    }
  };

  if (!canShare) return null; // Don't render the icon

  return (
    <IconButton onClick={handleShare}>
      <Share htmlColor="#F8F8F8" />
    </IconButton>
  );
};

export default AppShareButton;
